import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';
import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';
import { getShowArchiveFilterConfig } from '@/bundles/GroupFilters/helpers/filtersConfig/getShowArchiveFilterConfig';

export const getPressReleaseFilters = (): IFilterConfigItem[] => {
  return [
    // FilterCategoryEnum.press_release_details start
    {
      title: 'Status',
      name: 'pressrelease_status',
      type: FilterTypeEnum.one_select,
      items: [
        { text: 'New', value: 'feature' },
        { text: 'Pending Approval', value: 'pendingApproval' },
        { text: 'Sent', value: 'sent' },
      ],
      category: FilterCategoryEnum.press_release_details,
    },
    // FilterCategoryEnum.press_release_details end
    getShowArchiveFilterConfig(),
  ].filter(Boolean) as IFilterConfigItem[];
};
